module.exports = __webpack_public_path__ + "img/graphic-6.6d654628.png";